import { getCookie } from './cookie'

export const isDigitalPlusSubscriber = (): boolean => {
  if (!window.JSGlobals || !window.JSGlobals.piano?.subscription) return false

  const subscriberResource = getCookie('sub_resource')

  return subscriberResource === 'premium'
}
